import styled from '@mui/system/styled';
import { colors } from 'components/theme/constants';

export const QuickActionsCnt = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  padding: '30px 20px 60px 20px',

  '& .title': {
    fontWeight: 800,
    fontSize: 32,
    lineHeight: '42.69px',
    color: 'rgba(0, 0, 0, 0.87)',
    marginBottom: 7,
  },
  '& .subtitle': {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20.02px',
    color: 'rgba(0, 0, 0, 0.87)',
    marginBottom: 30,
  },
  '& .section': {
    background: colors.white,
    border: '1px solid #E0E0E0',
    boxShadow: '0px 30px 60px -30px rgba(0, 0, 0, 0.3)',
    borderRadius: 16,
    height: 371,
    padding: 10,
    cursor: 'pointer',
    '&:hover': {
      border: '1px solid #6868FE',
    },
    '& .imgCnt': {
      background: '#F4F7FA',
      border: '1px solid #EFEFEF',
      borderRadius: 8,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '10px 30px',
      minHeight: 200,
    },
    '& .contentCnt': {
      padding: 10,
    },
  },
  '& .actions': {
    display: 'flex',
    justifyContent: 'center',

    '& .title': {
      fontWeight: 700,
      fontSize: 19,
      lineHeight: '28px',
      letterSpacing: '-0.022em',
      color: 'rgba(0, 0, 0, 0.8)',
      marginBottom: 3,
    },
    '& .details': {
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '20.02px',
      letterSpacing: '0.17px',
      color: '#757575',
    },
  },
}));
